import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

const TYPES = {
  rinnovo: { label: "Rinnovo", cls: "bg-accent/10 text-accent" },
  disdetta: { label: "Disdetta", cls: "bg-destructive/10 text-destructive" },
  fine_sconto: { label: "Fine sconto", cls: "bg-amber-100 text-amber-800" },
  pagamento: { label: "Pagamento", cls: "bg-primary/10 text-primary" },
  altro: { label: "Altro", cls: "bg-slate-100 text-slate-700" },
};

const DAY = 86400000;

export function daysTo(d) {
  return Math.round((new Date(d + "T00:00:00").getTime() - new Date().setHours(0, 0, 0, 0)) / DAY);
}

function When({ date }) {
  const n = daysTo(date);
  const txt = n < 0 ? `scaduta da ${-n} gg` : n === 0 ? "oggi" : `tra ${n} gg`;
  const cls = n < 0 ? "text-destructive" : n <= 30 ? "text-amber-700" : "text-muted-foreground";
  return <span className={`text-xs font-bold ${cls}`}>{date.split("-").reverse().join("/")} · {txt}</span>;
}

export default function DeadlineList({ items, offerId, showClient, onToggled }) {
  const [rows, setRows] = useState(items || []);
  useEffect(() => {
    setRows(items || []);
  }, [items]);
  const toggle = async (r) => {
    const oid = offerId || r.offer_id;
    try {
      await api.patch(`/offers/${oid}/deadlines/${r.id}`, { done: !r.done });
      setRows(rows.map((x) => (x.id === r.id && (x.offer_id || oid) === oid ? { ...x, done: !r.done } : x)));
      if (onToggled) onToggled(r, !r.done);
    } catch {
      toast.error("Errore aggiornamento");
    }
  };
  if (!rows.length) return <p className="text-sm text-muted-foreground">Nessuna scadenza trovata.</p>;
  return (
    <ul className="space-y-2">
      {rows.map((r) => {
        const t = TYPES[r.type] || TYPES.altro;
        return (
          <li key={`${r.offer_id || ""}-${r.id}`} data-testid={`deadline-${r.id}`} className={`flex gap-3 items-start bg-white border border-border rounded-lg p-3 transition-opacity duration-200 ${r.done ? "opacity-50" : ""}`}>
            <Checkbox checked={r.done} onCheckedChange={() => toggle(r)} className="mt-1" data-testid={`deadline-done-${r.id}`} />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className={`text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded ${t.cls}`}>{t.label}</span>
                <span className={`font-bold text-navy text-sm ${r.done ? "line-through" : ""}`}>{r.title}</span>
                <When date={r.date} />
              </div>
              {showClient && (
                <Link to={`/offerte/${r.offer_id}/contratto`} className="text-xs font-semibold text-primary hover:underline">
                  {r.client}{r.agent_name ? ` · ${r.agent_name}` : ""}{r.agency_name ? ` (${r.agency_name})` : ""}
                </Link>
              )}
              {r.description && <p className="text-sm text-muted-foreground mt-0.5">{r.description}</p>}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
